import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';
import OrderInfo from './orderInfo.vue';
import ReturnOrderDetails from '@/views/assistant/components/returnOrderDetails.vue';
import TransportOrderDetails from '@/views/assistant/components/transportOrderDetails.vue';

var ClaimDetailPage = function (_super) {
  __extends(ClaimDetailPage, _super);

  function ClaimDetailPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.packageColumns = [{
      title: _this.t('商品编码'),
      dataIndex: 'product_sku'
    }, {
      title: _this.t('谷仓商品条码'),
      dataIndex: 'product_barcode'
    }, {
      title: _this.t('数量'),
      dataIndex: 'quantity',
      filterEmpty: true
    }, {
      title: _this.t('尺寸（CM）'),
      scopedSlots: {
        customRender: 'size'
      }
    }, {
      title: _this.t('重量（KG）'),
      dataIndex: 'weight'
    }];
    _this.logColumns = [{
      title: _this.t('操作人'),
      dataIndex: 'create_user_name'
    }, {
      title: _this.t('类型'),
      dataIndex: 'operate_type_text',
      filterEmpty: true
    }, {
      title: _this.t('理赔状态'),
      dataIndex: 'operate_after'
    }, {
      title: _this.t('操作时间'),
      dataIndex: 'create_time'
    }, {
      title: _this.t('备注'),
      scopedSlots: {
        customRender: 'note'
      }
    }];
    _this.breadcrumbData = [{
      routerName: 'ClaimsListPage',
      title: _this.t('理赔单')
    }, {
      title: _this.t('理赔单详情')
    }];
    _this.logLoadingStatus = false;
    _this.logPageSize = 20;
    _this.logPageIndex = 1;
    _this.logListTotal = 0;
    _this.detail = {};
    _this.fieldGroupList = [];
    _this.boxingList = [];
    _this.logList = [];
    return _this;
  }

  Object.defineProperty(ClaimDetailPage.prototype, "orderType", {
    get: function get() {
      return Number(this.$route.query.order_type) || this.detail.order_type || 1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ClaimDetailPage.prototype, "orderDetailComponent", {
    get: function get() {
      var componentMap = {
        1: OrderInfo,
        2: ReturnOrderDetails,
        3: TransportOrderDetails
      };
      return componentMap[this.orderType] || OrderInfo;
    },
    enumerable: false,
    configurable: true
  });

  ClaimDetailPage.prototype.created = function () {
    this.queryClaimDetails();
    this.queryLogList();
  };

  ClaimDetailPage.prototype.queryClaimDetails = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.assistant.queryClaimDetails({
              claim_bill_no: this.$route.query.claim_bill_no
            })];

          case 1:
            data = _a.sent().data;
            this.detail = data;
            this.fieldGroupList = data.field_group_list;

            if (this.orderType === 1) {
              this.queryBoxingList(data.order_code);
            }

            return [2];
        }
      });
    });
  };

  ClaimDetailPage.prototype.queryBoxingList = function (orderCode) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.order.queryBoxingList({
              code: orderCode
            })];

          case 1:
            data = _a.sent().data;
            this.boxingList = this.$util.createTableRowKey(data);
            return [2];
        }
      });
    });
  };

  ClaimDetailPage.prototype.queryLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, list, total;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.assistant.queryClaimLogList({
              claim_bill_no: this.$route.query.claim_bill_no,
              page_index: this.logPageIndex,
              page_size: this.logPageSize
            })];

          case 1:
            _a = _b.sent().data, list = _a.list, total = _a.total;
            this.logList = list;
            this.logListTotal = total;
            return [2];
        }
      });
    });
  };

  ClaimDetailPage.prototype.handlePreview = function (attachItem) {
    var url = this.$config.rfsFileDownloadUrl + "?path=" + attachItem.attach_path;

    if (this.$util.isImage(attachItem.attach_path)) {
      this.$previewImage({
        url: url
      });
    } else if (this.$util.isPdf(attachItem.attach_path)) {
      this.$previewPdf({
        url: url
      });
    } else {
      this.$message.warning(this.t('只能预览图片与pdf文件'));
    }
  };

  ClaimDetailPage.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.logPageIndex = pageIndex;
    this.logPageSize = pageSize;
    this.queryLogList();
  };

  __decorate([loading('loading')], ClaimDetailPage.prototype, "queryClaimDetails", null);

  ClaimDetailPage = __decorate([Component({
    components: {
      OrderInfo: OrderInfo,
      ReturnOrderDetails: ReturnOrderDetails,
      TransportOrderDetails: TransportOrderDetails
    }
  })], ClaimDetailPage);
  return ClaimDetailPage;
}(Vue);

export default ClaimDetailPage;